import React from 'react';
import { CommentsQueryProvider } from './providers/commentsQuery';
import CommentsModalTemplate from '../commentsModalTemplate';
import Wrapper from './components/Wrapper';
import Body from './components/Body';
import { useCommentsQuery as useRoomCommentsQuery } from './providers/commentsQuery';

const RoomCommentsRaw = ({
  addressId,
  queryOptions,
  hasModal = false,
  children,
}) => {
  return (
    <CommentsQueryProvider addressId={addressId} queryOptions={queryOptions}>
      <Wrapper addressId={addressId}>
        {children}
        {hasModal && (
          <CommentsModalTemplate.Modal>
            <Body />
          </CommentsModalTemplate.Modal>
        )}
      </Wrapper>
    </CommentsQueryProvider>
  );
};

const RoomComments = CommentsModalTemplate.extend(RoomCommentsRaw);

export { RoomComments, useRoomCommentsQuery };
